import Link from 'next/link';
import { CategoryProps } from '../../categoriesData';

export interface CategoriesMenuProps {
	testId?: string;
	categories: CategoryProps[];
	hideBackButton?: boolean;
}

const CategoriesMenu = (props: CategoriesMenuProps) => {
	const {
		testId = 'CategoriesMenu',
		categories,
		hideBackButton = false,
	} = props;

	return (
		<nav
			aria-label="Categories Menu"
			data-testid={testId}
			className="hvac-container flex justify-center"
		>
			<ul className="grid w-full max-w-124 grid-cols-2 gap-2 md:max-w-156 md:grid-cols-3 lg:max-w-max lg:grid-cols-6 lg:gap-4">
				{categories.map((category) => {
					const Icon = category.icon;

					if (category.name === 'All Categories' && hideBackButton) return null;

					return (
						<li
							key={category._id}
							className="h-full w-full rounded-2xl border-2 border-transparent bg-sky-50 transition-all ease-in-out hover:border-sky-700 lg:box-content lg:w-40"
						>
							<Link
								href={category.slug}
								className="block px-3 pb-3 pt-5 lg:px-4 lg:pb-5 lg:pt-7"
							>
								<div className="flex flex-col items-center justify-center text-center">
									<Icon className="mb-3 h-12 w-12 fill-sky-700 lg:mb-4" />
									<span className="text-sm font-semibold text-sky-700 lg:text-base">
										{category.name}
									</span>
								</div>
							</Link>
						</li>
					);
				})}
			</ul>
		</nav>
	);
};

export default CategoriesMenu;
